// removed by extract-text-webpack-plugin
module.exports = {"element_group":"_2XxAt","hasError":"_2Jnrb","label":"_347c8","error":"_2MDi9","description":"_2j74y"};


//////////////////
// WEBPACK FOOTER
// ./layouts/FormFieldLayout/styles.scss
// module id = 587
// module chunks = 0